import ProvenienzaAddModal from "./ProvenienzeAddModal.jsx";
export default ProvenienzaAddModal;
